export default function endUserReducer(state = {
    vehicle_db: {},
    vehicles: [],
    outstanding_bookings: [],
    completed_media: [],
    dismissed_bookings: [],
    dashboard_bookings: null,
    current_bookings: null,
    upcoming_bookings: null,
    pending_bookings: null,
    filters: [],
    loaded: false,
    pullout: false,
    current_booking: null,
    sidebar_data: null
}, action) {
    switch(action.type) {
        case "SET_EU_DATA" :{
            return state = {
                ...state,
                outstanding_bookings: action.payload.outstanding_bookings,
                vehicles: action.payload.vehicles,
                dashboard_bookings: action.payload.dashboard_bookings,
                filters: action.payload.filters,
                loaded: true
            }
        }

        case "SET_VEHICLE_DB" :{
            return state = {
                ...state,
                vehicle_db: action.payload.vehicle_db,
                vehicles: action.payload.vehicles
            }
        }

        case "SET_BOOKING" :{
            return state = {
                ...state,
                pullout: true,
                current_booking: action.payload
            }
        }

        case "CLOSE_PULLOUT" :{
            return state = {
                ...state,
                pullout: false,
                current_booking: null
            }
        }

        case "SET_OUTSTANDING_BOOKINGS_LIST" :{
            return state = {
                ...state,
                outstanding_bookings: action.payload
            }
        }

        case "SET_COMPLETED_MEDIA_LIST" :{
            return state = {
                ...state,
                completed_media: action.payload
            }
        }

        case "SET_DISMISSED_BOOKINGS_LIST" :{
            return state = {
                ...state,
                dismissed_bookings: action.payload
            }
        }

        case "SET_CURRENT_BOOKINGS_LIST" :{
            return state = {
                ...state,
                current_bookings: action.payload
            }
        }

        case "SET_UPCOMING_BOOKINGS_LIST" :{
            return state = {
                ...state,
                upcoming_bookings: action.payload
            }
        }

        case "SET_PENDING_BOOKINGS_LIST" :{
            return state = {
                ...state,
                pending_bookings: action.payload
            }
        }

        case "SET_SIDEBAR" :{
            return state = {
                ...state,
                sidebar_data: action.payload
            }
        }

        default: {

        }
    }

    return state;
}